export default {
  da: 'DK',
};
